export const resolveLocationFromState = (location: any): string => {
  if (location.state?.from) {
    return `${location.state?.from?.pathname}${location.state?.from?.search}`;
  }

  return '/dashboard';
};
